import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL



export function getSuscriptionselector() {
  return axios.get(API_URL+'/v1/suscription/')
}

export function getCloudSelector(id:String) {
  return axios.get(API_URL+'/v1/suscription/'+id+'/cloud/')
}

export function getDatePeriodBill(SuscriptionId:Number,) {
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId)
}

export function getUpdateDate(SuscriptionId:String, CloudAccountId:String, PeriodBill:String) {
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/cloud/'+CloudAccountId+'/lastDateUpdate/')
}


export function getGrafica(SuscriptionId:String, CloudAccountId:String,PeriodBill:String) {
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/cloud/'+CloudAccountId+'/dataforMonthForInstance', { params: { date: PeriodBill } })
}

export function getGraficamensual(SuscriptionId:Number) {
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/dataforMonthForInstance')
}

export function getTransfer(SuscriptionId:String, CloudAccountId:String,PeriodBill:String) {
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/cloud/'+CloudAccountId+'/dataforMonthForOperation', { params: { date: PeriodBill } })
}

export function getPeriodBill(SuscriptionId:String) {
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ListMonthForInput')
}

export function getDataAvailablesuscription(id:Number) {
  return axios.get(API_URL+'/v1/suscription/'+id)
}

export function getAvailableandExedente(SuscriptionId:String, CloudAccountId:String) {
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/cloud/'+CloudAccountId+'/AvailableMonth')
}

export function getDataDetailTable(SuscriptionId:Number,Year:string,mes:string,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/dataforMonthForConnector?year='+Year+'&month='+mes,{params:{cloud,region}})
}
export function getDataDetailTableglobal(SuscriptionId:Number,Year:string,mes:string,tenant:number,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/dataforMonthForConnector?year='+Year+'&month='+mes+'&tenantId='+tenant,{params:{cloud,region}})
}
export function getTableconnectorsyear(SuscriptionId:Number,Year:string,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/dataforMonthForConnector?year='+Year,{params:{cloud,region}})
}
export function getTableconnectorsyearglobal(SuscriptionId:Number,Year:string,tenant:number,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/dataforMonthForConnector?year='+Year+'&tenantId='+tenant,{params:{cloud,region}})
}

export function getTableconnectorsyears(SuscriptionId:Number,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/dataforMonthForConnector',{params:{cloud,region}})
}
export function getTableconnectorsyearsglobal(SuscriptionId:any,tenant:any,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/dataforMonthForConnector?tenantId='+tenant,{params:{cloud,region}})
}

export function getyear(SuscriptionId:Number){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ListYear')
}
export function getyearglobal(SuscriptionId:Number,tenant:number){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ListYear?tenantId='+tenant)
}

export function getmonth(SuscriptionId:Number){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ListMonths')
}
export function getmonthglobal(SuscriptionId:Number,tenant:number){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ListMonths?tenantId='+tenant)
}

export function getDataGrafica(SuscriptionId:Number, Year:string,mes:string,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ResumenHistorical?year='+Year+'&month='+mes,{params:{cloud,region}})
}
export function getDataGraficaglobal(SuscriptionId:Number, Year:string,mes:string,tenant:number,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ResumenHistorical?year='+Year+'&month='+mes+'&tenantId='+tenant,{params:{cloud,region}})
}
export function getDataGraficaanual(SuscriptionId:Number, Year:string,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ResumenHistorical?year='+Year,{params:{cloud,region}})
}

export function getDataGraficatodosanios(SuscriptionId:Number,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ResumenHistorical',{params:{cloud,region}})
}

export function getDataGraficatodosaniosglobal(SuscriptionId:Number,tenant:Number,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ResumenHistorical?tenantId='+tenant,{params:{cloud,region}})
}

export function getDataGraficaanualGlobal(SuscriptionId:Number, Year:string,tenant:number,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ResumenHistorical?year='+Year+'&tenantId='+tenant,{params:{cloud,region}})
}

export function getDataGraficatipo(SuscriptionId:Number, type:string,Year:string,mes:string,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ResumenHistorical?type='+type+'&year='+Year+'&month='+mes,{params:{cloud,region}})
}
export function getDataGraficatipoGlobal(SuscriptionId:Number, type:string,Year:string,mes:string,tenant:number,cloud?:any,region?:any){
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ResumenHistorical?type='+type+'&year='+Year+'&month='+mes+'&tenantId='+tenant,{params:{cloud,region}})
}

export function getListTenant(){
  return axios.get(API_URL+'/v1/tenant')
}

